<template>
    <b-list-group-item class="lista-menu" @click.stop="abrirModal()"
        ><span>RELATÓRIO DE CONSUMO DE ITENS DO CONTRATO</span>
        <filtro ref="filtroModal" @filtrar="obterRelatorio($event)"></filtro>
    </b-list-group-item>
</template>

<script>
import download from '../../../shared/download'
import filtro from './RelatorioConsumoItensContratoFiltro'
import RelatorioConsumoItensContratoServicos from './RelatorioConsumoItensContratoServicos'

export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        },

        obterRelatorio(filtro) {
            this.$store.dispatch('addRequest')
            RelatorioConsumoItensContratoServicos.obterRelatorioConsumoItensContrato(
                filtro
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Falha ao obter relatório',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        download(
                            response,
                            `Relatorio_Consumo_Itens_Contrato.xlsx`
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
